export default "__VITE_ASSET__BMlLzIu4__"